import { render, staticRenderFns } from "./paddle-products.vue?vue&type=template&id=6f305a4e&"
import script from "./paddle-products.vue?vue&type=script&lang=js&"
export * from "./paddle-products.vue?vue&type=script&lang=js&"
import style0 from "./paddle-products.vue?vue&type=style&index=0&id=6f305a4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports